import { useQuery } from '@tanstack/react-query';
import { activityService } from '@services';

// Get current user's activity
export const useMyActivity = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['activity', 'me', params],
    queryFn: () => activityService.getMyActivity(params),
    ...options,
  });
};

// Get activity for a project
export const useProjectActivity = (projectId, params = {}, options = {}) => {
  return useQuery({
    queryKey: ['activity', 'project', projectId, params],
    queryFn: () => activityService.getProjectActivity(projectId, params),
    enabled: !!projectId,
    ...options,
  });
};

// Get activity for a specific entity
export const useEntityActivity = (entity, entityId, params = {}, options = {}) => {
  return useQuery({
    queryKey: ['activity', entity, entityId, params],
    queryFn: () => activityService.getEntityActivity(entity, entityId, params),
    enabled: !!entity && !!entityId,
    ...options,
  });
};
